import React from "react";
import Sample from "./Sample";

class Samples extends React.Component {
  render() {
    return (
      <>
      <h3>Making Samples</h3>
       <p>In this page, I list out all post related to functionality of one funny sample funny product.</p>
       <p>These project was built based on my own experiences while studying and working over the years.</p>
       <p>If we combine all the procedures in the list, I hope it will make a simple system with integrated machine learning model.</p>
       <p>I will give explanation from embedded system in the first project and the second project is about web project</p>
       <p>Thoughout this project, I will give many concepts and explaination on it</p>
        <Sample />
      </>
    );
  }
}

export default Samples;
